import { Controller } from "@hotwired/stimulus"

// Filters a garment's gallery by media category.
//
// Everything is already in the DOM — this only toggles visibility, so no
// request is made and a crawler still sees every photograph.
export default class extends Controller {
  static targets = ["tab", "item"]

  filter(event) {
    const category = event.currentTarget.dataset.category

    this.itemTargets.forEach((item) => {
      const matches = category === "all" || item.dataset.category === category
      item.classList.toggle("hidden", !matches)
    })

    this.tabTargets.forEach((tab) => {
      const active = tab === event.currentTarget
      tab.setAttribute("aria-pressed", active ? "true" : "false")
      tab.classList.toggle("bg-ink", active)
      tab.classList.toggle("text-cream", active)
      tab.classList.toggle("border-ink", active)
      tab.classList.toggle("border-blush-200", !active)
      tab.classList.toggle("text-ink/70", !active)
    })
  }
}
